import { useEffect } from 'react'
import { useParams } from 'react-router'
import { observer } from 'mobx-react-lite'
import callingCnamCallerId from 'shared/assets/images/compliance/callingCnamCallerId.png'
import { getCDNAssetURL } from 'shared/lib'
import { PageDescription } from 'pages/settings/ui/PageDescription/PageDescription'
import { NextButton } from 'pages/settings/ui/NextButton/NextButton'
import { useCallingStepsContext } from 'pages/settings/pages/compliance/pages/calling/context/callingStepsContext'
import { PageErrorAlert } from 'pages/settings/pages/compliance/ui/PageErrorAlert/PageErrorAlert'
import styles from './styles.module.scss'

export const EnableCnamCallerId = observer(() => {
  const { id } = useParams()
  const {
    stepsStore: { setTotalSteps },
    cnamCallerIdStore: { errorMessage, moveToSecondStep, setPreassignedData },
  } = useCallingStepsContext()

  useEffect(() => {
    setTotalSteps(2)
    id && setPreassignedData(Number(id))
  }, [])

  return (
    <div>
      <PageDescription>{"Brand your outgoing calls with your company's name."}</PageDescription>

      <PageErrorAlert errorMessage={errorMessage} marginTop={20} />

      <img
        src={getCDNAssetURL(callingCnamCallerId)}
        alt={'callingCnamCallerId_image'}
        className={styles.image}
      />

      <NextButton text='Next' onClick={() => moveToSecondStep(id ? Number(id) : null)} />
    </div>
  )
})
